import React from "react"
import {
    Radio,
    Space,
} from "antd";

export const DataActionSelection = ({ dataAction, setDataAction }) => {
    return (
        <div
            style={{
                display: "flex",
                alignContent: "baseline",
                justifyContent: "center",
                width: "100%",
                columnGap: "2em",
                alignItems: "center",
                marginBottom: '1em'
            }}
        >
            <Radio.Group
                onChange={(e) => { setDataAction(e.target.value) }}
                value={dataAction}
                optionType="button"
            >
                <Space direction="horizontal" style={{ height: "auto" }}>
                    <Radio
                        value={"overwrite"}
                        style={{ height: "auto", whiteSpace: "nowrap" }}
                    >
                        <div style={{ lineHeight: 1.5 }}>
                            Add First Session of the day
                            <small style={{ display: "block" }}>
                                {" "}
                                (Overwrites any existing data for this day)
                            </small>
                        </div>
                    </Radio>
                    <Radio
                        value={"append"}
                        style={{
                            height: "auto",
                            whiteSpace: "nowrap",
                            marginLeft: "-1em",
                        }}
                    >
                        <div style={{ lineHeight: 1.5 }}>
                            Add subsequent Sessions
                            <small style={{ display: "block" }}>
                                {" "}
                                (Adds to existing data for this day)
                            </small>
                        </div>
                    </Radio>
                </Space>
            </Radio.Group>
        </div>
    )
}